// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".descriptionText[data-v-87c5a0ae] :first-child :nth-child(3) :first-child{overflow:inherit!important;text-overflow:clip!important;white-space:normal!important}", ""]);
// Exports
module.exports = exports;
